import { render, staticRenderFns } from "./MembershipsEdit.vue?vue&type=template&id=0819d54f"
import script from "./MembershipsEdit.vue?vue&type=script&lang=js"
export * from "./MembershipsEdit.vue?vue&type=script&lang=js"
import style0 from "./MembershipsEdit.vue?vue&type=style&index=0&id=0819d54f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports